export function showToast(
  type: 'success' | 'fail' | 'warning' | 'none',
  message: string | HTMLElement,
  duration?: number
) {
  if (typeof window !== 'undefined') {
    const toast = document.createElement('div');
    toast.classList.add('toast', `toast-${type}`);
    if (message instanceof HTMLElement) {
      toast.append(message);
    } else {
      toast.textContent = message;
    }
    document.body.append(toast);
    setTimeout(
      () => {
        toast.remove();
      },
      type === 'fail' ? 8000 : duration ?? 3000
    );
  }
}
